import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

// Zip Game's own Firebase project. Named "zip" so this app instance never
// collides with the other two games' instances in the same page.
const firebaseConfig = {
  apiKey: 'AIzaSyA_N6XgfH1HDlpnwtl6z27poKFEoe2vgxg',
  authDomain: 'zip-game-c819a.firebaseapp.com',
  projectId: 'zip-game-c819a',
  storageBucket: 'zip-game-c819a.firebasestorage.app',
  messagingSenderId: '407530945506',
  appId: '1:407530945506:web:eab9bcb57ce78840d397bb',
  measurementId: 'G-2EV64BP62K',
};

export const app = initializeApp(firebaseConfig, 'zip');
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'asia-southeast1');
